'use strict';

import React, { useState } from 'react';

import { connect } from 'react-redux';

import classnames from 'classnames';
import OTButton from '../../tag/OTButton';
import { FormattedMessage } from 'react-intl';
import OTIcon from '../../tag/OTIcon';
import BaseQuestionnaireListItem from '../BaseQuestionnaireListItem';
import { showOmavointiQuestionnaireModal } from '../../../data/questionnaires/actions';
import { QUESTIONNAIRES } from '../../../data/reducer';
import MobileClientModal from '../MobileClientModal';
import { LONG_DESCRIPTON_FORM_CODE } from '../../../definitions/QuestionnaireConstants';
import get from 'lodash/get';
import { getTime } from '../../../utils/TimeUtils';

const { id: module_id } = module;

function QuestionnaireActiveList(props) {
  const [showMobileClientModal, setShowMobileClientModal] = useState(false);

  const toggleModalState = () => {
    setShowMobileClientModal(!showMobileClientModal);
  };

  const clicked = (data) => {
    let { showOmavointiQuestionnaireModal, mobileClientState } = props;

    !mobileClientState
      ? showOmavointiQuestionnaireModal(data.formCode)
      : toggleModalState();
    return null;
  };

  /*
    If the questionnaire is 15d, show the description given in the data.
    Else show generic description
  */
  const renderLongDescription = (questionnaire) => {
    return questionnaire.formCode === LONG_DESCRIPTON_FORM_CODE ? (
      questionnaire.longDescription && (
        <div>{questionnaire.longDescription}</div>
      )
    ) : (
      <div>
        <FormattedMessage id={`${module_id}.generic.info`} />
      </div>
    );
  };

  let omavointiQuestionnaires = props.data;
  let completed = false;

  return (
    <>
      <BaseQuestionnaireListItem
        left={
          <>
            {omavointiQuestionnaires.map((questionnaire) => {
              let endDateTime = get(questionnaire, 'endDateTime', null) ? (
                <FormattedMessage
                  id={`${module_id}.fill.at.the.latest`}
                  values={{
                    date: getTime(questionnaire.endDateTime).format(
                      'DD.MM.YYYY'
                    ),
                  }}
                />
              ) : null;
              return (
                <div className={'ot-queryitem-no-border'}>
                  <span className={'ot-queryitem__name'}>
                    {questionnaire.name}
                  </span>
                  {renderLongDescription(questionnaire)}
                  {questionnaire.description && (
                    <>
                      <span
                        className={classnames('ot-queryitem__description', {
                          completed,
                        })}
                      >
                        <OTIcon
                          config={{
                            type: 'custom',
                            name: 'palaute',
                            color: 'darkblue',
                          }}
                          style={{
                            height: '13px',
                            width: '15px',
                            marginRight: '5px',
                          }}
                        />
                        {questionnaire.description}
                      </span>
                    </>
                  )}
                  {endDateTime && <div>{endDateTime}</div>}
                </div>
              );
            })}
          </>
        }
        leftWidth={'span6'}
        right={
          <>
            {
              <OTButton
                color={'light'}
                className={'pull-right ot-queryitem__button'}
                onClick={clicked.bind(this, omavointiQuestionnaires[0])}
              >
                <FormattedMessage id={'navigate.to.answer'} />
              </OTButton>
            }
          </>
        }
        rightWidth={'span3'}
      />
      {showMobileClientModal && (
        <MobileClientModal
          isOpen={showMobileClientModal}
          hideModal={() => toggleModalState()}
        />
      )}
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    mobileClientState: state[QUESTIONNAIRES].mobileClientState,
  };
};

export default connect(mapStateToProps, { showOmavointiQuestionnaireModal })(
  QuestionnaireActiveList
);
